const INCREMENT = 'INCREMENT';
const DECREMENT = 'DECREMENT';
const VERTICAL = 'VERTICAL';
const HORIZONTAL = 'HORIZONTAL';
const HEAD = 'HEAD';
const TAIL = 'TAIL';
const I_BLOCK = 'inline-block';
const BLOCK = 'block';
const NONE = 'none';
const noOp = () => {};

export {
  INCREMENT,
  DECREMENT,
  VERTICAL,
  HORIZONTAL,
  I_BLOCK,
  HEAD,
  TAIL,
  BLOCK,
  NONE,
  noOp
};



// WEBPACK FOOTER //
// ./lib/utils/constants.js